export enum HomeOffice {
    No = 1,
    Possible = 2,
    Mandatory = 4,
}